import request from '@/utils/infrastructure/communication/request';

export async function queryConnectionPermissions(connectionType, serverId = null, params = {}) {
  const url = `/connection/permissions/${connectionType}${serverId ? `/${serverId}` : ''}`;

  try {
    const response = await request(url, {
      method: 'GET',
      params,
    });
    return response;
  } catch (error) {
    throw error;
  }
}
